export const loadTypers = (typerDivs) => {
  typerDivs.forEach((div) => new Typer(div));
};

class Typer {
  constructor(div) {
    this.div = div;
    this.words = JSON.parse(div.dataset.typerWords);
    this.currentIndex = -1;
    this.insertCursor();
    this.type();
  }

  async insertCursor() {
    this.div.insertAdjacentHTML('afterend', '<span class="typer-cursor">|</span>');
    const element = this.div.nextElementSibling;
    setInterval(() => element.classList.toggle('typer-cursor--blinked'), 600);
  }

  async type() {
    const word = await this.getNextWord();
    for (let i = 0; i <= word.length; i++) {
      await this.sleep(this.getRandomDuration(100, 150));
      this.setText(word.substring(0, i));
    }
    await this.sleep(200);
    for (let i = word.length; i >= 0; i--) {
      await this.sleep(this.getRandomDuration(100, 140));
      this.setText(word.substring(0, i));
    }
    this.type();
  }

  getRandomDuration(min, max) {
    const range = max - min;
    return min + Math.random() * range;
  }

  async setText(text) {
    this.div.innerHTML = text;
  }

  async getNextWord() {
    this.currentIndex++;
    if (this.currentIndex >= this.words.length) this.currentIndex = 0;
    return this.words[this.currentIndex];
  }

  async sleep(msec) {
    return new Promise((resolve) => setTimeout(resolve, msec));
  }
}
